export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: false,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_mrpSalesStockOutNo') || '销售出库单编号',
    field: 'mrpSalesStockOutNo',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.order_form_label_orderNo') || '订单编号',
    field: 'orderNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    field: 'SalesStockOutStatus',
    headerAlign: 'center',
    minWidth: 90,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
    slots: { default: 'status' }
  },
  {
    title: that.$l('INDEX.form_label_stockOutDate') || '出库日期',
    field: 'stockOutDate',
    headerAlign: 'center',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('form_label_warehouse_name') || '出库仓库',
    field: 'warehouseName',
    headerAlign: 'center',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.label_customer') || '客户名称',
    field: 'custName',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.table_label_contactMemo') || '备注',
    field: 'remark',
    headerAlign: 'center',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.creator') || "创建人",
    width: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: {
      default: "createInfo",
    },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || "修改人",
    width: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: { default: "modifyInfo" },
  },

]
